export class FinalBeneficiariesAnswers {
    Id: number;
    IdRequest: number;
    PartnersAreFinalBeneficiariesQuestion: boolean;
    ShareFinalBeneficiariesInformation: boolean | null;
    FinalBeneficiariesJustification: string | null;
    create_By: string;
    create_Date: Date;
    modified_By: string;
    modified_Date: Date;
}